<div class="filter-for-list">
  <h4> {{'OMP_MANUAL'|translate}}</h4>
</div>
<mat-vertical-stepper>

  <!-- <mat-step>

       <ng-template matStepLabel>Table des matières</ng-template>
       <mat-horizontal-stepper>
           <mat-step>

               <ng-template matStepLabel>Démarrer</ng-template>

               <a href="">Login</a> <br>
               <a href="">Tableau de bord</a> <br>
               <a href="">Description du tableau de bord</a> <br>
               <a href="">Changer la langue</a> <br>
               <a href="">Gérer son compte OSMOS</a> <br>
               <a href="">Accéder aux Niveaux, Utilisateurs, Projets, Equipements</a>


           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des Niveaux</ng-template>
               <a href="">Effectuer une recherche parmi les niveaux</a> <br>
               <a href="">Afficher tous les niveaux/uniquement les niveaux disponibles</a> <br>
               <a href="">Ajouter un niveau</a> <br>
               <a href="">Afficher/Editer un niveau</a>


           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des utilisateurs</ng-template>
               <a href="">Rôle des utilisateurs</a> <br>
               <a href="">Rechercher un utilisateur</a> <br>
               <a href="">Afficher uniquement les utilisateurs disposant d'un rôle spécifique</a> <br>
               <a href="">Ajouter un utilisateur</a><br>
               <a href="">Afficher/Editer/réinitialiser un utilisateur</a>

           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des projets</ng-template>
               <a href="">Rechercher un projet</a> <br>
               <a href="">Afficher les projets actifs/inactifs</a> <br>
               <a href="">Ajouter un projet</a> <br>
               <a href="">Utiliser les boutons projet</a><br>
               <a href="">Gérer les alarmes</a><br>
               <a href="">Graphe</a>

           </mat-step>
           <mat-step>
               <ng-template matStepLabel>Gestion des équipements</ng-template>
               <a href="">Types d'équipements</a> <br>
               <a href="">Rechercher un équipement</a> <br>
               <a href="">Filtrer les équipements indisponibles/inactifs</a> <br>
               <a href="">Ajouter un équipement</a><br>
               <a href="">Transférer des équipements vers un niveau</a>

           </mat-step>
           <mat-step>
               <ng-template matStepLabel>Option Maths</ng-template>
               <a routerLink="" fragment="maths">Option Maths</a> <br>
           </mat-step>
       </mat-horizontal-stepper>


   </mat-step> -->

  <mat-step>

    <ng-template matStepLabel>Démarrer avec OSMOS Project Manager</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Login</ng-template>
        <p class="texte">
          Navigateur : utilisez de préférence Google Chrome <br>
          Dans votre navigateur renseignez l'adresse suivante : <a routerLink="/login">https://store.osmos-group.com/login</a>
          <br>
          Renseignez votre nom d’utilisateur et mot de passe puis, cliquez sur "Login".<br>
          <img src="assets/images/noticeOPM/fr1.png" alt="Login"> <br>
          Si vous avez oublié votre mot de passe, cliquez sur "Forgot Password ?", puis renseignez votre
          adresse e-mail et cliquez sur "Send".
        </p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Tableau de bord</ng-template>
        <p class="texte">
          Une fois connecté, vous arrivez sur la page d'accueil ou "Tableau de bord" qui vous permet d'avoir
          une vue sur l'ensemble de vos utilisateurs, équipements et utilisateurs ainsi que leurs différents
          projets.
          Vous pouvez gérer les utilisateurs, leurs niveaux d’accès, leurs projets ainsi que leurs équipements
          grâce au menu de tête (bandeau supérieur) qui vous permettra d’accéder à la page correspondante.
          <br>
          <img src="assets/images/noticeOPM/tableaudebord1.png" style="width: 750px" alt="Login"><br> <br>
          Description du tableau de bord : <br>
          <img src="assets/images/noticeOPM/descriptiontableaudebord.png" alt="Login"><br></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Changer la langue</ng-template>
        <p class="texte">Passez du français à l’anglais en cliquant simplement sur ce bouton : <br>
          <img src="assets/images/noticeOPM/img3.png" alt="Login">
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Changer de Niveau</ng-template>
        <p class="texte">Changez de niveau facilement en utilisant ce bouton: <br>
          <img src="assets/images/noticeOPM/niveau1.png" style="width: 750px" alt="Login">
        <p>Le niveau sélectionné est sauvegardé localement</p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Gérer son compte</ng-template>
        <br>
        <p class="texte">Pour gérer son compte OSMOS, cliquez sur « Mon compte » dans le bandeau de tête : <br>
          <img src="assets/images/noticeOPM/img4.png" alt="Login"> <br>
          Vous avez alors accès à toutes les informations sur votre compte et le Niveau qui lui est lié. <br>Pour
          éditer ces informations, appuyer sur le bouton « crayon » : <br>
          <img src="assets/images/noticeOPM/img4,5.png" alt="Login"></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>EDAS connexion</ng-template>
        Les utilisateurs d'OPM peuvent vérifier la connectivité de leurs stations EDAS en cliquant sur ce bouton: <br>
        <img src="assets/images/noticeOPM/stations.png"> <br>
        En cliquant sur le bouton "œil", les détails du EDAS seront affichés. Vous pouvez également cliquer directement
        sur le lien vers l'EDAS :
        <img src="assets/images/noticeOPM/stations2.png"> <br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Accéder aux Niveaux, Utilisateurs, Projets, Equipements, Abonnements Spéciaux, SAFE
          Manager
        </ng-template>
        Naviguer vers les pages Niveaux, Utilisateurs, Projets et Equipements grâce à ces six boutons : <br>
        <img src="assets/images/noticeOPM/img5.png" alt="Login">
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>

    </mat-horizontal-stepper>

  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Gérer les niveaux</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Effectuer une recherche de Niveaux</ng-template>
        <p class="texte">Remplissez ce champ afin d'effectuer une recherche parmi les niveaux : <br>
          <img src="assets/images/noticeOPM/img6.png" alt="niveau"></p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Afficher tous les Niveaux/Uniquement les Niveaux actifs</ng-template>
        <p class="texte"> Cliquez simplement sur ce bouton : <br>
          <img src="assets/images/noticeOPM/img6,5.png" alt="niveau"></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Ajouter un Niveau</ng-template>
        <p class="texte">Tout d’abord cliquez sur ce bouton : <br>
          <img src="assets/images/noticeOPM/img7.png"><br>
          Une première fenêtre popup s'affiche : <br>
          <img src="assets/images/noticeOPM/img8.png"><br>
          Renseignez ici votre Nom, Email et Langue, puis si le niveau est actif ou pas, puis cliquez sur «
          Suivant ». Vous accédez alors à l’étape suivante : <br>
          <img src="assets/images/noticeOPM/img9.png"><br>
          Vous pouvez alors renseignez l’adresse, le code postal, la ville, le pays et ajoutez des notes pour
          ce niveau. Cliquez ensuite sur « Suivant », ou Retour si vous voulez modifier les informations
          renseignées précédemment. Vous accédez alors à l’étape de vérification et sauvegarde : <br>
          <img src="assets/images/noticeOPM/img10.png"><br>
          Vérifiez alors les champs renseignés et cliquez sur « Retour » pour pouvoir les modifier. Si tout
          est juste, cliquez alors sur « Sauvegarder » pour enregistrer le nouveau niveau créer. Il apparait
          alors dans la liste des Niveaux : <br>
          <img src="assets/images/noticeOPM/img11.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Afficher/Editer un Niveau</ng-template>
        <p class="texte">
          Vous pouvez à tout moment consulter les informations du niveau ainsi que les éditer en cliquant
          respectivement sur le bouton œil ou le bouton crayon correspondant au niveau choisi :
          <img src="assets/images/noticeOPM/img12.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>

    </mat-horizontal-stepper>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Gérer les utilisateurs</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Rôles des Utilisateurs</ng-template>
        <p class="texte">
          Il existe 10 rôles qui donnent différents accès aux fonctionnalités du site. Chaque utilisateur a au
          moins un rôle et peut en avoir autant que nécessaire. <br>
          Les rôles sont : <br>
        <ul>
          <li>User : donne accès à OSMOS Project Manager</li>
          <li>Client : donne accès à SAFE WORKS pour les projets associés</li>
          <li>Installer : nécessaire pour l'installation de certains capteurs</li>
          <li>Level Admin : permet la création et l'édition d'Users pour le niveau</li>
          <li>Engineer : donne accès à SAFE ANALYZER pour les projets associés</li>
          <li>Production : donne l'accès à l'onglet Devices en lecture et écriture</li>
          <li>Data Scientist : rôle User + accès à l'onglet Maths</li>
          <li>All Levels for SAFE : donne tous les droits et accès à SAFE</li>
          <li>Business: rôle user et client</li>
          <li>Contact : User pour les alertes</li>
        </ul>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Rechercher un Utilisateur</ng-template>
        <p class="texte">
          Pour rechercher un Utilisateur, utilisez le bouton suivant : <br>
          <img src="assets/images/noticeOPM/img14.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Afficher uniquement un rôle</ng-template>
        <p class="texte">
          Pour afficher uniquement les utilisateurs disposant d’au moins un rôle particulier, cliquez sur le
          rôle à afficher parmi les options suivantes :<br>
          <img src="assets/images/noticeOPM/img16.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Ajouter un Utilisateur</ng-template>
        <p class="texte">
          Pour ajouter un Utilisateur, cliquez tout d’abord sur ce bouton situé en haut de la page : <br>
          <img src="assets/images/noticeOPM/img17.png"><br>
          S’ouvre alors ce pop-up : <br>
          <img src="assets/images/noticeOPM/img18.png"><br>
          Renseignez alors les informations nécessaires : Nom, Prénom, Email, Langue ainsi que si
          l’utilisateur est actif ou non (téléphone optionnel). Cliquez ensuite sur suivant, vous accédez
          alors au pop-up de définition des rôles :<br>
          <img src="assets/images/noticeOPM/img19.png"><br>
          Cochez alors tous les rôles que vous souhaitez assigner au nouvel Utilisateur. Au moins un rôle doit
          être sélectionné. Validez en cliquant sur suivant. <br>
          Un troisième pop-up s’ouvre alors : <br>
          <img src="assets/images/noticeOPM/img20.png"><br>
          Choisissez un mot de passe puis cliquez sur suivant.
          Un pop-up réunissant les informations renseignées s’affiche : <br>
          <img src="assets/images/noticeOPM/img21.png"><br>
          Vérifiez vos informations : modifiez-les en cliquant sur « Retour », ou sauvegardez-les en cliquant
          sur « Sauvegarder ». Une fois la sauvegarde effectuée, l’Utilisateur nouvellement crée apparait dans
          la liste des utilisateurs :<br>
          <img src="assets/images/noticeOPM/img22.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Afficher/Editer/Réinitialiser un Utilisateur</ng-template>
        <p>
          Vous pouvez à tous moments visionnez les informations liées à l’Utilisateur en appuyant sur le
          bouton « œil » en face de l’utilisateur souhaité. Vous pouvez également éditer un utilisateur en
          appuyant sur le bouton « crayon ». Enfin en utilisant le bouton « clef », vous pouvez envoyer un
          mail de réinitialisation de mot de passe à l’Utilisateur. <br>
          <img src="assets/images/noticeOPM/img23.png"><br>

        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>


  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Gérer les projets</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Rechercher un Projet</ng-template>
        <p class="texte">
          Pour rechercher un projet, utiliser le bouton suivant : <br>
          <img src="assets/images/noticeOPM/img24.png"><br>
          Pour changer l'affichage entre les projets actifs et les projets inactifs, cliquez sur ce bouton :
          <br>
          <img src="assets/images/noticeOPM/img25.png"><br>
        </p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Ajouter un projet</ng-template>
        <p class="texte">
          Pour ajouter un projet, cliquez d'abord sur le bouton suivant : <br>
          <img src="assets/images/noticeOPM/img26.png"><br>
          S'ouvre alors l'étape suivant : <br>
          <img src="assets/images/noticeOPM/img27.png"><br>
          Renseignez alors la date de début du projet, la date de fin, le nom du projet, son code ainsi qu'une
          description du projet. Validez en cliquant sur "suivant".<br> L'étape suivante apparaît : <br>
          <img src="assets/images/noticeOPM/img28.png"><br>
          Il faut alors renseignez l’adresse du projet. Pour ce faire, deux options sont possibles : <br>
          1) Placer le projet directement sur la carte. L’adresse se remplira automatiquement sur le
          formulaire. A noter qu’une vue satellite ainsi qu’une vue « plan » sont disponibles. <br>
          2) Renseignez l’adresse directement dans le formulaire. Le point sur la carte s’actualisera
          automatiquement.<br>
          Vous pouvez ensuite remplir le champs Notes. Cliquez ensuite sur « Accepter » pour valider
          l’adresse. Vous pouvez à tout moment réinitialiser la carte et le formulaire en cliquant sur le
          bouton « Réinitialiser ». <br> <br>
          Une fois l’adresse renseignée et acceptée, cliquez sur le bouton « suivant » en bas à gauche de
          votre écran.<br>
          L’étape de récapitulation des informations renseignées apparaît :<br>
          <img src="assets/images/noticeOPM/img29.png"><br>
          Vérifiez les informations liées au projet puis cliquez sur « sauvegardez » si elles sont justes,
          sinon modifiez-les en appuyant sur « Retour ».<br>
          <br>
          Après la sauvegarde, trois nouvelles étapes que vous pouvez configurer apparaissent : <br>
          4-Utilisateurs<br>5-Equipements<br>6-Emplacements<br>
          <img src="assets/images/noticeOPM/img30.png"><br>
          Ajoutez un utilisateur grâce au bouton « Ajouter un utilisateur ». Supprimez-le grâce au bouton «
          croix » en rouge en face de l’utilisateur. Désigner-le client principal grâce au bouton « client
          principal ». Cliquez sur suivant pour accéder à l’étape Equipements.<br>
          <img src="assets/images/noticeOPM/img31.png"><br>
          A cette étape vous pouvez ajouter des équipements à votre projet grâce au bouton « Ajouter un
          équipement ». Vous pouvez ensuite modifier l’équipement ajouté en cliquant sur l’équipement, puis
          validez en appuyant sur le bouton vert. Modifiez l’ID du projet en cliquant sur cette dernière. Il est
          également possible de générer automaticquement les emplacement associé.
          Supprimez un équipement en cliquant sur la croix rouge. Vous pouvez également activer/désactiver le
          mode éditeur en cliquant sur le cadenas. Cliquez ensuite sur suivant pour accéder à l’étape «
          Emplacement ».<br>
          <img src="assets/images/noticeOPM/img32.png"><br>
          Remplissez le champ « nom » (et parent le cas échéant) puis cliquez sur « Ajouter un emplacement ».
          Il apparaît alors dans la liste des emplacements. Vous pouvez dès lors le modifier grâce au bouton
          de validation vert, lui ajouter un équipement grâce au bouton « assigner un équipement », le
          supprimer avec le bouton « croix » rouge. Un emplacement ne peut plus être supprimé une fois qu’un
          équipement lui est assigné<br> Vous avez la possibilité de verrouiller/déverrouiller le mode éditeur
          grâce au bouton « cadenas ». <br>Votre projet apparaîtra dans la liste des projets :<br>
          <img src="assets/images/noticeOPM/img33.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Utiliser les boutons projets</ng-template>
        <p class="texte">
          <img src="assets/images/noticeOPM/img34.png"><br>
          1) Bouton œil : permet d’accéder au récapitulatif des informations liées au projet.<br>
          2) Bouton crayon : permet d’éditer les informations liées au projet.<br>
          3) Bouton cloche : permet de visionner, éditer, créer et supprimer des alarmes pour ce projet <br>
          4) Bouton tableur Excell : ouvre la fenêtre d’exportation des mesures des capteurs <br>
          5) Bouton graphique : permet de visionner le graphique des mesures des capteurs<br>
          6) Bouton dernières mesures : Cliquez ici pour afficher les dates de dernières mesures
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Gérer les alarmes</ng-template>
        <p class="texte">
          Après avoir cliqué sur le bouton orange « alarme », la page suivante s’ouvre :<br>
          <img src="assets/images/noticeOPM/img35.png"><br>
          Trouvez une alarme grâce au champs « recherche », au bouton filtrant les alarmes actives/inactives
          ou en sélectionnant le type d’alarme (location, threshold,…,) en haut de la page :<br>
          <img src="assets/images/noticeOPM/img36.png"><br>
          Ajoutez une alarme en cliquant sur « ajoutez une Alarme », le popup suivant s’ouvre alors :<br>
          <img src="assets/images/noticeOPM/img37.png"><br>
          Choisissez le type d’alarme et nommez-la. Appuyez ensuite sur suivant pour accéder à la prochaine
          étape :<br>
          <img src="assets/images/noticeOPM/arlarmoubli.png"><br>
          Vous devez ici affecter une priorité à votre alarme. Cliquez sur suivant pour accéder à l'étape
          suivante.<br>
          <img src="assets/images/noticeOPM/img38.png"><br>
          Il faut alors affecter l’alarme à un ou plusieurs emplacements. Cliquez sur « +Ajouter un
          emplacement », sélectionnez les emplacements concernés par l’alarme puis validez en cliquant sur «
          Suivant ». L’étape d’après apparaît<br>
          <img src="assets/images/noticeOPM/vocalalarm.png"><br>
          Cette étape sert à désigner les utilisateurs qui seront avertis par l’alarme. Cliquez sur « ajouter
          un utilisateur » pour abonner un ou plusieurs utilisateurs à cette alarme. Déterminez ensuite la ou les
          manières par lesquelles les utilisateurs seront notifiés en cas de déclenchement d'alarme : via sms, email,
          et/ou appel vocal. Validez en cliquant sur
          suivant.
          <br>L’étape de récapitulation apparait :<br>
          <img src="assets/images/noticeOPM/img40.png"><br>
          Vérifiez les informations renseignées et cliquez sur « Sauvegarder ». L’alarme apparaît alors dans
          la liste.<br><br>

        <h4>Alertes de fonctionnement :</h4>
        Les utilisateurs d'OPM peuvent configurer une alerte de fonctionnement sur une ou plusieurs locations afin d'en
        contrôler la réception des données et la pertinence de ces dernières. Elle doit être assignée à une, plusieurs,
        ou toutes les locations grâce à l'onglet suivant : <br>
        <img src="assets/images/noticeOPM/imgoperatingalarm.png"><br>
        <h4>Alarme Combinatoire :</h4><br>
        Les utilisateurs OPM peuvent créer une alarme combinée en utilisant le bouton «ajouter une alarme» sur la page
        d'alarme du projet
        et en sélectionnant la puce «alarme combinée». Les utilisateurs OPM doivent d’abord saisir le nom de l’alarme,
        puis construire l' expression d'alarme: <br> <br>

        Alarme1 [opérateur: et / ou / xor] Alarme2 [et / ou / xor] Alarme3 [et / ou / xor]… <br> <br>

        Les utilisateurs peuvent créer l’expression en cliquant sur les puces des alarmes et des opérateurs ou en
        écrivant directement dans l' expression (avec complétion automatique). <br>

        Un message doit être ajouté: <br> <br>
        <img src="assets/images/noticeOPM/combinationalarm.png">

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Utiliser le graphe</ng-template>
        <p class="texte">Une fois le bouton graphe cliqué, la page suivante s’affiche :<br>
          <img src="assets/images/noticeOPM/graph1.png" style="width: 700px;"><br>
          Renseignez les paramètres souhaités pour l'affichage du graphe dans le premier rectangle rouge
          et les emplacements voulus dans le deuxième.<br>
          Vous pouvez également modifier l'heure en cliquant sur le bouton horloge encadré :<br>
          <img src="assets/images/noticeOPM/graph0.png"><br>
          <br> Nouveautés du graphe : <br> <br>
          <img src="assets/images/noticeOPM/img41.png"><br>
          Les nouveautés sont entourées en rouge :<br><br>
          Le bouton « vue de l’axe », entouré en vert dans le premier cadre rouge, permet d’afficher/masquer
          la
          vue des axes, ici affiché dans le rectangle rouge le plus à droite. Dans ce cadre il est alors
          possible
          d’afficher/masquer chacun des quatre axes, de les afficher au choix à gauche ou à droite du graphe,
          ou
          encore de leur assigner une limite maximale ou minimale.<br>
          Le dernier cadre rouge permet de changer le type de graphique. Par défaut c’est un graphique en
          ligne,
          mais vous pouvez afficher un graphique en aires, en colonnes, un graphique « spline » et un
          graphique en
          aires « spline ». Vous pouvez également choisir de voir une courbe « en escalier ».<br>
          Enfin, il est possible de grouper les données par période de 1 à 12 heures / jours / semaines / mois
           </p> <br>
        Sachez que chacunes de vos actions (jusqu'aux 20 dernieres) sont enregistrées dans votre espace local, il est
        ainsi possible d'annuler ou de rétablir vos actions en cliquant sur les flêches précédentes et suivantes situées
        à côtés du nom de la vue. <br>
        <br><br>
        <p>Il est également possible de réorganiser l'arbre des emplacements. Pour ce faire, cliquer sur le bouton
          suivant : <br> <img src="assets/images/noticeOPM/dragDropAccess.png"><br></p>
        Après une fenêtre de confirmation, la modale drag & drop suivante s'affiche : <br> <img
        src="assets/images/noticeOPM/dragDropModale.png" style="height: 500px"><br>
        Vous pouvez alors réogarniser simplement vos emplacements et locations au moyen d'un glisser-déposer.
        L'interface permet aussi de créer de nouveau emplacement, ou de supprimer un emplacement vide.

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Offset, Effaceur</ng-template>
        Pour utiliser l'option Offset cliquez tout d'abord sur cette icone : <br>
        <img src="assets/images/noticeOPM/graph3.png"><br>
        Pour utiliser l'effaceur de données cliquez sur cette icone:<br>
        <img src="assets/images/noticeOPM/graph2.png"><br>
        La fenêtre suivante apparaît alors, utilisez les onglets pour naviguer entre Offset et effaceur de données :
        <br>
        <img src="assets/images/noticeOPM/offseroreraser.png"><br>
        Offset : Sélectionnez tout d'abord les capteurs concernés. Déterminez ensuite une valeur d'Offset,
        activez si besoin l'offset sur les mesures futures ou passées via le bouton toggle puis la date.
        Appuyez sur le bouton Valider : le tableau d'offset et le graphe sont alors mis à jour <Br>
        SmartOffsetMode: Si l'utilisateur n'a pas activé les données compensées thermiquement et que la plage de temps
        du graphique est inférieure à 24h ou si le nombre de points sur le graphe est inférieur à 140, le
        le smart offset mode peut être activé via toggle: <img src="assets/images/noticeOPM/som.png"><br>. Des drapeaux
        apparaîtront alors sur le graphique avec une valeur égale à la
        différence entre ce point et le précédent. Cliquer sur les drapeaux ouvrira la modale offset avec la valeur, les
        données et
        l'emplacement déjà rempli. Le smart offset mode peut être quitté en cliquant sur le bouton <br>
        Effaceur de données : Déterminez la date de départ et la date de fin ainsi que les capteurs concernés par les
        données que vous souhaitez neutraliser sur le graphe. Cliquez ensuite sur Validez pour mettre à jour le tableau
        de suppressions des données ansi que le graphe.<br>
        Seuils sur le graphe : Sélectionnez une date de début et de fin ainsi que la valeur du seuil lié à un emplacement pour le faire s'afficher sur la courbe
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Sauvegarde de vues</ng-template>
        Vous pouvez à tout instant décider de sauvegarder les paramètres et la vue du graphe. Pour ce faire, cliquez sur
        le bouton : <img src="assets/images/noticeOPM/saveView01.png" alt="save view" style="width:400px"><br>
        Il est possible de noter la vue comme "favorite" afin de la faire apparaître en premier dans la liste des vues.
        Le bouton suivant permet d'accéder à la liste des vues : <img src="assets/images/noticeOPM/saveView02.png"
                                                                      alt="save view" style="width:400px"><br> Sur
        l'interface de liste de vue, il est possible d'y accéder ou de supprimer la vue : <br> <img
        src="assets/images/noticeOPM/saveView03.png" alt="save view" style="width:800px"> <br>
        Lorsqu'une vue en cours est modifiée, il est possible de mettre à jour ces modifications ou de cloner une
        nouvelle vue à partir de celle-ci en cliquant sur le bouton de sauvegarde de vue.<br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Exporter les données</ng-template>
        Pour ouvrir la fenêtre permettant l'exportation des données au format CSV, cliquez sur ce bouton
        situé en haut à droite de la page du graphe : <img src="assets/images/noticeOPM/exp1.png"><br>
        S'affiche alors la page suivante : <br><br>
        <img src="assets/images/noticeOPM/exp2.png" alt="export CSV" style="width:1000px"><br>
        <p style="text-underline: #333333"> Remplissez alors les paramètres suivants : <br></p>
        -Date de début <br>
        -Date de <br>
        -Types de mesures <br>
        -Données depuis le module SMS<br>
        -Types de données<br>
        -Types d'unités<br>
        -Equipements dont les données doivent être exportées<br><br>

        Option 1 - export rapide (données légères) : <br>
        - Une fois les paramètres de l'exportation déterminés, vous pouvez démarrer un export rapide de données légères
        en cliquant sur :
        <img src="assets/images/noticeOPM/exp3.png" alt="export CSV"><br>
        Option 2 - Planification de l'export (données massives) <br>
        - Le bouton 'Planifier un export': <img src="assets/images/noticeOPM/plannifExport.png"><br> permet de lancer un
        export massif de données. L'utilisateur est notifié par mail du démarrage d'export des données, puis lorsque
        l'opération est terminée. L'utilisateur peut retrouver le statut de ses exports en cours ou terminés en cliquant
        sur 'statut des exports': <img src="assets/images/noticeOPM/exportlist.png"><br>
        Sur la page statut des exports, l'utilisateur peut télécharger son export, l'annuler ou le supprimer, et obtenir
        plus d'information sur un export en cours ou terminé. Il peut également suivre l'avancement de son export en
        temps réel.
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>


      </mat-step>
    </mat-horizontal-stepper>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Gérer les équipements</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Types d'équipements</ng-template>
        Les différents équipements sont :<br>
        Liris V2 <br>
        Optical<br>
        External<br>
        Temperature<br>
        Inclino V2<br>
        Liris V3<br>
        Inclino V3<br>
        Gateway<br>
        SPCU<br>
        DAU<br>
        Extenso V3<br>
        Incli-bi V2<br>
        v_sensor<br>
        G_sensor<br>
        Liris 420 v3
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Rechercher/Filtrer les équipements, recherche multi-niveaux</ng-template>
        <p class="texte">
          Pour rechercher un équipement dans la liste, utilisez le champ ci-dessous.<br>
          <img src="assets/images/noticeOPM/img42.png"><br>
          Les boutons ci-dessous permettent de filtrer les équipements actifs/inactifs :<br>
          <img src="assets/images/noticeOPM/img43.png"><br>
          Pour ne voir qu’un seul type d’équipement parmi Liris V2, Optical, External, Temperature, Inclino
          V2, Liris V3, Inclino V3, Gateway, SPCU, DAU, Extenso V3, Incli-bi V2,<br> cliquez sur le type
          d’équipement voulu ici :<br>
          <img src="assets/images/noticeOPM/img44.png"><br>
          Les utilisateurs OSMOS_Group ayant le rôle production ont accès à la modale de recherche d'équipement en
          multi-niveau.<br>
          Pour ce faire, entrez simplement l'UID de l'équipement après avoir cliqué sur : <br>
          <img src="assets/images/noticeOPM/deviceFinder.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Ajouter un équipement</ng-template>
        Pour ajouter un équipement, cliquez d'abord sur ce bouton :<br>
        <img src="assets/images/noticeOPM/img45.png"><br>
        Le pop-up suivant apparaît :<br>
        <img src="assets/images/noticeOPM/img46.png"><br>
        Choisissez alors le type d’équipement à ajouter, son ID, sa longueur (dans le cas où l’équipement en a
        une) et son statut (Actif/Inactif).<br>
        Validez en cliquant sur Suivant. Un second popup s’affiche :<br>
        <img src="assets/images/noticeOPM/img47.png"><br>
        Entrez alors les paramètres A, B, C ainsi que le « trigger » de l’équipement. Validez pour accéder au
        popup récapitulatif :<br>
        <img src="assets/images/noticeOPM/img48.png"><br>
        Appuyez sur « Retour » si vous avez des modifications à faire. Sinon, cliquez sur « Sauvegarder ». <br>Le
        nouvel équipement apparaît alors dans la liste des équipements.
        Pour afficher ou éditer les équipements, utilisez respectivement les boutons « œil » et « crayon »
        situés en face de l’équipement à afficher ou éditer :<br>
        <img src="assets/images/noticeOPM/img49.png"><br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>

        <ng-template matStepLabel>Capteur Virtuel</ng-template>
        Les utilisateurs OPM peuvent créer un équipement v-sensor en définissant un ID et une unité. Lors de la
        sauvegarde, le "v-sensor" nouvellement créé
        sera répertorié parmi d'autres équipements. Les paramètres ne peuvent pas être configurés tant que le
        "v-sensor" n'a pas été enregistré
        dans la liste des équipements et tant qu'il n'a pas été affecté à un emplacement. Les utilisateurs OPM peuvent
        voir les
        informations liées
        à un v-sensor en cliquant sur le bouton "oeil". En cliquant sur le bouton “crayon”, les utilisateurs OPM sont
        autorisés à
        modifier les informations du v-sensor telles que son ID, son unité et, si il a déjà été affecté à un
        emplacement,
        ses paramètres. Les paramètres à saisir doivent être de la forme "Constante + [A x (Capteur_A1 ^ a1) x
        (Capteur_A2 ^ a2)] + [B x (Capteur_B1 ^ b1) x (Capteur_B2 ^ b2)] +… ”
        Lors de la sauvegarde, les paramètres nouvellement modifiés seront mis à jours.
        <img src="assets/images/noticeOPM/v_sensor_img.png">
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Ajout d'équipements par lot</ng-template>
        Il est possible d'importer plusieurs équipement du même type à la fois. Pour ce faire, veuillez tout d'abord
        cliquer sur le bouton Import CSV :
        <img src="assets/images/noticeOPM/equipementlotfr.png"><br>
        S'ouvre alors l'interface suivante : <br>
        <img src="assets/images/noticeOPM/interfacelotfr.png"><br>
        Sélectionnez alors le template correspondant au type d'équipement que vous souhaitez importer. Un fichier csv
        sera alors téléchargé. Ouvrez le et remplissez le. Attention si l'UID commence par un ou plusieurs 0, il est
        necessaire de changer le format de cellule en "texte" afin qu'ils ne soient pas automatiquement supprimés.
        Certains paramètres sont obligatoires, d'autres sont facultatifs selon le type d'équipement que vous souhaitez
        intégrer. <br>
        Une fois le classeur rempli, sélectionnez-le via "choisir un fichier" puis cliquez sur le bouton "sauvegarder"
        Si le classeur est rempli adéquatement vos équipements seront importés, sinon un message d'erreur vous indiquera
        avec précision où sont les erreurs.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Transférer un équipement vers un autre niveau</ng-template>
        Le bouton caddie permet de déplacer un ou plusieurs équipements vers un autre Niveau. Il apparaît
        lorsque l’option de filtre : <img src="assets/images/noticeOPM/img50.png"> est désactivée ainsi : <img
        src="assets/images/noticeOPM/img51.png"><br>
        On le trouve ici (entouré en rouge) : <br>
        <img src="assets/images/noticeOPM/img52.png"><br>
        Sélectionner d’abord un ou plusieurs équipements grâce aux cases entourées en vert. Cliquez ensuite sur
        le caddie pour voir apparaître le popup suivant :<br>
        <img src="assets/images/noticeOPM/img53.png"><br>
        Choisissez alors un niveau puis cliquez sur déplacer. Vos équipements sont alors réaffectés au niveau
        sélectionné.  
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </mat-step>

  <mat-step>
    <ng-template matStepLabel id="maths">Abonnements</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Correction thermique</ng-template>
        <p class="texte">Certains Utilisateurs ont accès à l’option « Maths » (ceux avec le rôle « data scientist » )
          :<br>
          <img src="assets/images/noticeOPM/img54.png"><br>
          Cette page permet l’abonnement au module Maths pour un projet:<br> <br>
          Trouvez tout d’abord le projet en question grâce à l’outil recherche et au filtre projet actif/inactif :<br>
          <img src="assets/images/noticeOPM/img55.png"><br>
          Cliquez sur ce bouton pour accéder au popup de souscription :<br>
          <img src="assets/images/noticeOPM/img56.png"><br>
          Vous devez ensuite renseigner les dates de début et fin de souscription :<br>
          <img src="assets/images/noticeOPM/img57.png"><br>
          Puis remplir les champs nécessaires si l’option statique est activée :<br>
          <img src="assets/images/noticeOPM/img58.png"><br>
          Enfin vous devez remplir les champs requis si l’option dynamique est activée :<br>
          <img src="assets/images/noticeOPM/img59.png"><br>
          Vérifiez les informations renseignées, puis cliquez sur sauvegarder en bas du popup récapitulatif :<br>
          <img src="assets/images/noticeOPM/img60.png"><br>
          Le projet est alors abonné au module Maths</p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Rapport automatique (beta, en developpement)</ng-template>
        <p class="texte">Se rendre sur l'onglet rapport automatique :<br>
          <img src="assets/images/noticeOPM/autoreport2.png"><br>
          Créer un rapport automatique via le formulaire :<br>
          <img src="assets/images/noticeOPM/autoreport0.png"><br>
          Uploader via un fichier JSON pour la création d'un rapport automatique :<br>
          <img src="assets/images/noticeOPM/autoreport1.png"><br>
          Télécharger le rapport automatique au format JSON après création :<br>
          <img src="assets/images/noticeOPM/autoreport3.png"><br></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>

        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Statisques d'évènements dynamiques</ng-template>
        <p>Afin d'activer l'onglet "EventDyn" de la page projet de SAFE, les utilisateurs peuvent abonner un projet aux statistiques d'évènements dynamiques en appuyant sur le bouton "+" devant le projet concerné

        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>

        </div>
      </mat-step>


      <mat-step>
        <ng-template matStepLabel>Senceive</ng-template>
        Abonnement d'un projet aux données SENCEIVE : <br>
        Après avoir sélectionné le jeton "SENCEIVE" dans le menu de tête, à l'intérieur de l'onglet "spécial" cliquez
        simplement sur le bouton "+" devant le
        simplement sur le bouton "+" devant leera
        projet que vous souhaitez abonner aux données SENCEIVE. <br> La fenêtre suivante apparaît :
        <img src="assets/images/noticeOPM/special1.png"><br>
        Renseignez alors l'id du projet SENCEIVE, le User senceive et le mot de passe associé. Vérifiez et
        sauvegardez : le projet est dès lors abonné aux données senceive.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>CSV-SFTP</ng-template>
        Export automatique de données CSV vers des SFTP :
        Après avoir sélectionée le jeton CSV-SFTP dans le menu de tête, cliquez simplement sur le bouton "+" devant le
        projet concerné <br> La fenêtre suivante apparaît :
        <img src="assets/images/noticeOPM/special2.png"><br>
        Précisez tout d'abord si l'export doit générer ou non les fichiers statiques, dynamiques, en temps réel.
        Renseignez ensuite le server SFTP, son port, son User et son mot de passe. Enfin, décidez ou non de conserver
        les données en base. Vous pouvez alors sauvegarder : l'export automatique est dès lors programmé.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>NEWSTEO</ng-template>
        Abonnement des projets aux données NEWSTEO : <br>
        Après avoir sélectionné le jeton "NEWSTEO" dans le menu de tête, cliquez simplement sur le bouton "+" devant le
        projet que vous souhaitez abonner aux données NEWSTEO. <br> La fenêtre suivante apparaît :
        <img src="assets/images/noticeOPM/special3.png"><br>
        Renseignez alors simplement l'id de projet NEWSTEO puis sauvegardez : le projet est désormais abonné aux données
        NEWSTEO

        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-step>

</mat-vertical-stepper>

